<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["getTourCategoryTitle"]),
  },
};
</script>

<template>
  <div class="c-loading">
    <div class="loading">
      <div class="loading__wrapper">
        <div class="loading__progress">
          <div class="loading__progress-filler" />
        </div>

        <span class="loading__icon"></span>

        <label>کمی صبر کنید</label>

        <p>در حال یافتن بهترین تور ها برای شما هستیم</p>
        <span class="loading__subtitle">{{ getTourCategoryTitle }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "../style/modules/loading.scss";
</style>
